import { PolicyBillingNotification, PolicyBillingSettings } from "@deathstar/types/northstar";
import React from "react";
import { IOptions as PaymentsTabOptions } from "./Payments";
import { IOptions as PoliciesTabOptions } from "./Policies";
import { IOptions as SettingsTabOptions } from "./Settings";

export interface IContext extends PoliciesTabOptions, PaymentsTabOptions, SettingsTabOptions {}

export const Context = React.createContext<IContext>({
    isLoading: false,
    paymentHistoryData: [],
    policies: [],
    stripeDashboardLink: "",
    cancelProcessingPayment: () => Promise.resolve(),
    user: undefined,
    contacts: [],
    billingInfo: undefined as unknown as SettingsTabOptions["billingInfo"],
    isError: false,
    account: undefined as unknown as SettingsTabOptions["account"],
    createCustomer: undefined as unknown as SettingsTabOptions["createCustomer"],
    onSubmitBillingProfileChange: () => Promise.resolve(),
    onWaypointsSubscriptionChange: () => Promise.resolve(),
    onPaymentSuccess: () => Promise.resolve(),
    onUpdatePolicyBillingSettings: () => Promise.resolve({} as PolicyBillingSettings),
    onUpdatePolicyBillingNotification: () => Promise.resolve({} as PolicyBillingNotification),
    navigateToReporting: () => {
        /**/
    },
    subscription: undefined as unknown as SettingsTabOptions["subscription"],
    createPayment: undefined,
    enableActions: false,
    isLoadingBillingInfo: undefined,
    onAllowToAddCCChange: function (_tier: boolean): Promise<void> {
        return Promise.resolve();
    },
});
